import React from 'react';

const PageHeader = ({ title, subtitle, badge }) => (
  <div className="mb-12">
    {badge && (
      <span className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider text-brand-700 uppercase bg-brand-100 rounded-full">
        {badge}
      </span>
    )}
    <h1 className="text-4xl md:text-5xl font-serif font-bold text-slate-900 mb-4 leading-tight">
      {title}
    </h1>
    {subtitle && (
      <p className="text-xl text-slate-600 font-light max-w-3xl leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);

export default PageHeader;